// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonStack {
    justify-content: flex-end;
    flex-shrink: 0;
}

.baseDialogContent {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow: hidden;
    max-height:100vh;
}`, "",{"version":3,"sources":["webpack://./src/app/components/dialogs/basedialog/base.dialog.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".buttonStack {\n    justify-content: flex-end;\n    flex-shrink: 0;\n}\n\n.baseDialogContent {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    overflow: hidden;\n    max-height:100vh;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
